<template>
  <div>
    <NavBarAdmin></NavBarAdmin>
    <h2 class="mt-3 titleP"><i>Sección administrativa del software de cotización de Dobladora y Cortadora
        Santafe</i></h2>
    <div class="card p-1 mt-3 mb-3 w-75 mx-auto border-danger">
      <p class="ms-2 me-2 mt-3">Tenga en cuenta que para crear cualquier especificación de materia prima o bien cualquier
        grupo de
        formas para las lineas (Láminas, Perfiles y Tubos) que meneja la compañia, es
        <strong><i>indispensable</i></strong> que exista primero la familia de materia prima asociada.
      </p>
      <p class="ms-2 me-2">Revise el <router-link class="link1" to="/Admin/ListRMts&Vars">Catálogo de materias
          primas</router-link>, sí ninguna obecede a sus necesidades cree una nueva haciendo uso del siguiente
        registro.</p>
      <RawMatRegister class="container"></RawMatRegister>
    </div>
    <FooterAdmin></FooterAdmin>
  </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue";
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue";
import RawMatRegister from "@/components/Admin/RawMaterial/RegisterRawMatComponent.vue";
export default {
  name: "Home Admin",
  components: {
    NavBarAdmin,
    FooterAdmin,
    RawMatRegister,
  },
  data() {
    return {
      familiesResult: [],
      showFamilyListComp: false,
    };
  },
  methods: {
    showList(data) {
      // data.forEach(element => {
      //   console.log("desde el padre"+element.id);
      // });
      this.familiesResult = data;
      //console.log(this.familiesResult);
      this.showFamilyListComp = true;
    },
    closeList() {
      this.showFamilyListComp = false;
    }
  },
};
</script>
<style scoped>
.link1 {
  color: #9d0e15;
}

.titleP {
  text-shadow:
    2px 1px 2px #877879,
    0 0 1em #CCCCC3,
    0 0 0.2em #CCCCC3;
  color: rgb(23, 1, 1);
  /* font:
    1.5em Georgia,
    "Bitstream Charter",
    "URW Bookman L",
    "Century Schoolbook L",
    serif; */
  /* text-shadow: 5px 2px 3px #9d0e15; */
}
</style>